import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * On a client-side SPA the document never reloads, so the window keeps its
 * scroll position when you move between routes — click a link halfway down the
 * feed and the next page opens already scrolled down. This resets the scroll to
 * the top on each new navigation.
 *
 * We skip POP (browser back/forward) so the browser's own scroll restoration
 * can return you to where you were, and we honour an in-page #hash target.
 * Renders nothing.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === 'POP') return; // back/forward — let the browser restore
    if (hash) return; // a #section link wants to land on that element
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname, hash, navType]);

  return null;
}
